import { FRAMEWORK_VERSION } from '@cessi/content';

export const FRAMEWORK_BASE =
  (import.meta.env.VITE_FRAMEWORK_SITE_BASE_URL as string | undefined)?.replace(/\/$/, '') ||
  'http://localhost:4174/latest';

export const FRAMEWORK_SELLO = `${FRAMEWORK_VERSION} · borrador`;

/** Ruta de la autoevaluación (base de Vite); la raíz del dominio es el inicio del framework. */
export const APP_RUTA = '/autoevaluacion/';

/** `corta`: etiqueta para pantallas angostas (≤760 px), igual que en el sitio. */
export type SolapaFramework = { id: string; etiqueta: string; corta?: string; href: string };

/** Mismas solapas y orden que la barra `.top` del sitio oficial. */
export function solapasFramework(base: string = FRAMEWORK_BASE): SolapaFramework[] {
  const b = base.replace(/\/$/, '');
  return [
    { id: 'framework', etiqueta: 'Framework', href: `${b}/framework.html` },
    { id: 'capacidades', etiqueta: 'Capacidades', href: `${b}/capacidades.html` },
    { id: 'autoevaluacion', etiqueta: 'Autoevaluación', href: APP_RUTA },
    { id: 'guia', etiqueta: 'Guía para directivos', corta: 'Guía', href: `${b}/guia.html` },
    { id: 'tablero', etiqueta: 'Tablero', href: `${b}/tablero.html` },
    { id: 'descargas', etiqueta: 'Descargas', href: `${b}/descargas.html` },
    { id: 'participar', etiqueta: 'Participar', href: `${b}/participar.html` },
  ];
}

export function inicioFramework(base: string = FRAMEWORK_BASE): string {
  return `${base.replace(/\/$/, '')}/index.html`;
}

export type EnlaceFramework = { id: string; etiqueta: string; href: string };

/** Mismos enlaces y orden que el `<footer>` del sitio oficial. */
export function enlacesPie(base: string = FRAMEWORK_BASE): EnlaceFramework[] {
  const b = base.replace(/\/$/, '');
  return [{ id: 'legal', etiqueta: 'Aviso legal', href: `${b}/acerca.html#legal` }];
}

export const FRAMEWORK_ANIO = '2026';

/** Última línea del pie del sitio: versión publicada, sin «borrador». */
export const FRAMEWORK_FIRMA_PIE = `Espacio de Innovación con IA · CESSI · Mesa de Innovación · ${FRAMEWORK_VERSION} · ${FRAMEWORK_ANIO}`;

/** Material del framework enlazado desde la pantalla de resultados. */
export function enlacesResultados(base: string = FRAMEWORK_BASE) {
  const b = base.replace(/\/$/, '');
  return {
    perfil: `${b}/guia.html#como-leer-el-perfil-de-la-organizacion`,
    guia: `${b}/guia.html`,
    plantilla90Dias: `${b}/descargas/Plantilla_Plan_90_dias.pdf`,
  };
}
